<template>
  <Authenticator class="my-2">
    <div class="md my-2">
      <div v-if="!loading">
        <div class="row px-3 py-2 my-0">
          <span class="my-2 mb-3 text-center email-title">
            <i>{{ email_address }}</i>
          </span>
          <h1>Badges</h1>
        </div>
        <div class="row m-2 mx-4 text-center"
             v-if="badges.length==0">
          <p>
            No badges.
          </p>
        </div>
        <div class="row mt-0 px-2 mx-2 pb-4">
          <table>
            <tbody>
              <tr v-for="badge in badges"
                  :key="badge.name">
                <td class="text-center">
                  <span class="icon">
                    {{badge.icon}}
                  </span>
                </td>
                <td>
                  <span class="badge-title">
                    <b>{{badge.title}}</b>
                  </span>
                </td>
                <td>
                  <i>{{badge.description}}</i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row m-2">
          <p>
            <i>
              Only users from within the organisation (...@{{ organisation }}) can view these badges.
            </i>
          </p>
        </div>
      </div>
      <div class="d-flex justify-content-center align-items-center"
           v-if="loading">
        <div class="spinner-border m-2" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  </Authenticator>
</template>

<script>
  import Authenticator from '@/authenticator/authenticator.js'
  import { get_badges, post_user } from '@/backend/backend.js'
  import { get_valid_email } from '@/badges/badges.js'


  export default {
    components: {
      Authenticator
    },
    data() {
      return {
        badges: [],
        loading: true,
      }
    },
    created() {
       document.title = "Badges of " + this.email_address
    },
    mounted() {
      console.debug('Requesting badges')
      get_badges(
        this.email_address
      )
        .then(badges => {
          this.loading = false

          if (!badges) {
            console.debug('There are no badges')
            return
          }

          this.badges = [...badges.badges].sort((a, b) => a.id.localeCompare(b.id))
        })

      post_user()
    },
    computed: {
      email_address() {
        var email_address = get_valid_email(this.$route.params.email)
        if (!email_address) {
          // eslint-disable-next-line
          this.$router.push('/404')
          this.$forceUpdate()
          return null
        }
        return email_address
      },
      organisation() {
        return this.email_address.split("@")[1]
      }
    }
  }
</script>

<style scoped>
  .md {
    text-align: left;
    background-color: rgb(43, 43, 43);
    border-radius: 10px;
  }

  .email-title {
    font-size: 25px;
    word-break: break-all;
  }

  .badge-title {
    font-size: 18px; 
  }

  .icon {
    font-size: 60px;
  }

  img {
    width: 100%;
  }

  table, th, td {
    color: #fff;
    border-collapse: collapse;
  }
  tr {
    background-color: rgb(43, 43, 43) !important;
  }
</style>
